$(document).ready(function () {

  function initMobileDropdown() {

    if (window.matchMedia('(max-width: 767px)').matches) {

      $('.menu.dropdown_child').each(function () {
        var wrapper = $(this);

        wrapper.find('.menu_link').each(function () {
          var item = $(this);
          var title = item.find('.main_nav_title');
          var content = item.find('.menu.dropdown_grandchild');

          if (!title.length || !content.length) return;

          if (item.hasClass('active')) {
            content.css('max-height', content[0].scrollHeight + 'px');
          } else {
            content.css('max-height', '0px');
          }

          title.off('click.mobileDropdown').on('click.mobileDropdown', function (e) {
            e.preventDefault();

            if (item.hasClass('active')) {
              item.removeClass('active');
              content.css('max-height', '0px');
            } else {
              item.addClass('active');
              content.css('max-height', content[0].scrollHeight + 'px');
            }
          });

        });
      });

    } else {
      $('.menu.dropdown_grandchild').css('max-height', '');
    }

  }

  initMobileDropdown();

  $(window).on('resize', function () {
    initMobileDropdown();
  });

});



function extractNumber(value) {
  return value
    .replace(/[^0-9.]/g, '')      // remove everything except numbers & dots
    .replace(/(\..*)\./g, '$1');  // keep only the first dot
}

jQuery(document).ready(function() {
 function updateItemsHtml(html) {    
      var mf = window.variantStrings.mf;
      var total = Shopify.formatMoney(html.items_subtotal_price, mf);
    
      var str = '';
    
      if ( html.item_count > 0 ) {
        document.getElementById("empty-cart-id").style.display = "none";
        html.items.forEach(function(item, index) {
          var prod_title = item.product_title;
          var prod_image = '<div class="card-img var_'+ item.id +'"><a href="'+ item.url +'"></a></div>';
          var final_price = item.final_line_price;
          var original_price = item.original_line_price;
          var discounted_price = item.discounted_price;
          var indexNumber = index + 1; 
          var featured_img = item.featured_image.url;
          // build prod price.
          var prod_price = '';
          var original_price = item.original_line_price;
          if (original_price!=final_price) {
            prod_price += '<div><p>' + Shopify.formatMoney(discounted_price,mf) + '</p></div>';
          } else {
            prod_price += '<div><p>' + Shopify.formatMoney(original_price,mf) + '</p></div>';
          }
  
          // build variant.
          var dVariant = '<div class="card_price_wrrap"><dl>';
          if (!item.product_has_only_default_variant) {
              item.options_with_values.forEach(function(variant_item, index) {
                
                  dVariant += '<h4 class="product-option" key="vrnt-'+ index +'">';
                // dVariant += variant_item.name +' : ';
                  dVariant += variant_item.value;
                  dVariant += '</h4>';
                
            });        
          }
          if (item.properties["Letter Charms"]){
              dVariant += '<h4 class="product-option">Letter Charms: ';
              dVariant += item.properties["Letter Charms"];
              dVariant += '</h4>';
          }
         dVariant += '</dl>';
         dVariant += '<p class="card-item-qty ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '">x '+ item.quantity +'</p>';
         dVariant += '</div>';
  
          // build quantity form.
          var decIcon = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg>';
          var incIcon = ' <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg>';
          
          var qtyStr = '<div class="card_content_bottom btm-item-' + item.id + ' ' + (item.handle === 'ossa-gift-card' ? 'gift-product' : '') + '"><div class="quantity--container"><div class="quentity'+(item.handle == 'ballchain-with-charms-and-letters'? ' hidden': '' )+'">';
          qtyStr += '<quantity-input class="quantity">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for '+ item.title +'</span>'+ decIcon +'</button>';
          qtyStr += '<input class="quantity__input ossn-quantity__input" type="number" name="updates[]" value="'+ item.quantity +'" min="0" aria-label="Quantity for '+ item.title +'" id="Drawer-quantity-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          qtyStr += '<button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for '+ item.title +'</span>'+ incIcon +'</button>';
          qtyStr += '</quantity-input>';
          qtyStr += '</div> </div><div class="cart_card_price"><p>'+prod_price+'</p></div></div>';
  
          var removeIcon = '<div class="remove_product_cart"><cart-remove-button id="CartDrawer-Remove-'+ indexNumber +'" data-index="'+ indexNumber +'">';
          removeIcon += '<button class="button button--tertiary" aria-label="Remove '+ item.title +'">';
          removeIcon += '<span class="remove--button--style"><svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="12.8028" y1="2.19682" x2="2.19617" y2="12.8034" stroke="#ED4A24"></line><line x1="2.1973" y1="2.19674" x2="12.8039" y2="12.8033" stroke="#ED4A24"></line></svg></span></button></cart-remove-button></div></div>';
  
          str += '<div id="CartDrawer-Item-'+ indexNumber + '" class="product-cart-list">';
          str += '<div class="card_details">';
          // str += '<div><p>'+ prod_title +'</p></div>';
          // str += prod_price;
          str += '<div class="middle_content_card">' + prod_image;
          str += '<div class="card-content"><div class="top_heading_card">';
          str += '<div><p>'+ prod_title +'</p></div></div>' + dVariant +'<div class="space_between_card"></div>'+ qtyStr + '</div>' + removeIcon +'</div>'; 
          str += '</div></div>';

          $.get('/cart?view=alternat_cart', function(cart, textStatus) {  
          var cart_img = $(cart).find('.card-img.var_'+item.id).html();
          if($(cart).find('.grid_pre_order.product-cart-'+item.id).length > 0){
            var pre_order = $(cart).find('.grid_pre_order.product-cart-'+item.id).find('.pre_order_est_date').html();
            $('<p class="preorder_cart">PREORDER</p><p class="pre_order_est_date">'+pre_order+'</p>').insertBefore(".btm-item-"+item.id);
          }
          setTimeout(function(){
            $('.var_'+item.id).html(cart_img);
          },100)
          });
          
        });
        str += '<div class="related_wrraper_main"></div>';
        document.getElementById("drawer__wrapper").classList.remove("empty-cart");
        document.getElementById("empty-cart-id").style.display = "none";
        document.getElementById("CartDrawer-Checkout").disabled = false;
          // Update Free-Shipping Bar.
           $.get('/cart?view=alternat_cart', function(cart, textStatus) {
            var freeShip = $(cart).find('.free-shipping-notice').html();
            $('.free-shipping-notice').html(freeShip);
            var upsell = $(cart).find('.related_wrraper_main').html();
            $('body').find('.related_wrraper_main').html(upsell);
          });
      } else {
        // show cart is empty
        // console.log('else');
        document.getElementById("empty-cart-id").style.display = "flex";
        var empty_image_url = document.getElementById("empty-cart-id").dataset.image;
        var emptyStr = '<div class="product-cart-list drawer__inner-empty">';
        emptyStr += '<div class="empty_cart">';
        emptyStr += '<h2 class="empty_text">Your cart is empty</h2>';
        emptyStr += '<a class="empty-cart-link"  href="/">Start Shopping</a><img src="'+ empty_image_url +'" alt="cart is empty">';
        emptyStr += '</div></div>';
        document.getElementById("empty-cart-id").innerHTML = emptyStr;
        document.getElementById("CartDrawer-Checkout").disabled = true;
        document.getElementById("drawer__wrapper").classList.add("empty-cart");

      }
      
      // update html
      document.getElementById("totals__subtotal-value").innerHTML = total;
      document.getElementById("cart-total").innerHTML = total;
      document.getElementById("bag-count").innerHTML = html.item_count;
      document.getElementById("bagCnt").innerHTML = html.item_count;
      document.getElementById("CartDrawer-CartItems").innerHTML = str;
    }
const config = fetchConfig('javascript');
$('body').on('click','.quickadd_pro',function(e){
    e.preventDefault();
    var var_id = $(this).attr('data-variant-id');
    var arr=[
        {
            quantity: 1,
            id: var_id
        }
    ]
     $.ajax({
      type : 'POST',
      url : '/cart/add.js',
      dataType : 'json',
      data : {items:arr},
      success : function(data){
           fetch(`${routes.cart_update_url}`, config)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                updateItemsHtml(parsedState);
                document.body.classList.add('testbody');
                document.getElementById("drawer-name").classList.add("is-active","is-visible");
                document.body.classList.add('has_drawer');
            }).catch((e) => {
              console.error(e);
            });    
      },
      error : function(){
        console.log('eror');
      }
    });
})
  
  $('body').on('change','.product__info-container .color_var_wp :radio',function() {
      var optionValue = jQuery(this).val();
      var var_id = jQuery(this).attr('data-variant');
      var var_cord_price = jQuery(this).attr('data-cord-price');
      var var_cordcase_price = jQuery(this).attr('data-cordcase-price');
      $('.cord-price').text(var_cord_price + ' Cord');
      $('.cord-item h4.price').text(var_cord_price);
      $('.cordcase-price').text(var_cordcase_price + ' Set');
      // $('.cordcase-item h4.price').text(var_cordcase_price);
      if(!$('#change_btn_text_by_jquery').is('[data-ossa-confessa]')) $('.cordcase-item h4.price').text(cord_case_price);
      window.updateBundleTotalPrice();
      var varsel = document.querySelector("variant-selects");
      var case_select = document.getElementsByClassName("selecttype-COLOR")[0];
      case_select.dispatchEvent(new Event('change'));
      case_select.value = optionValue;
      varsel.dispatchEvent(new Event('change'));
    });

    $('body').on('click','.case_var_wp li',function() {
          var optionValue = jQuery(this).find('a').text();
          $('.select__select').val(optionValue);
          var varsel = document.querySelector("variant-selects");
          var case_select = document.getElementsByClassName("select__select")[0];
          case_select.dispatchEvent(new Event('change'));
          case_select.value = optionValue;
          varsel.dispatchEvent(new Event('change'));
          var var_price = $('.case_var_wp select option:selected').attr('data-price');
          $('#change_btn_text_by_jquery').find('span.text-add-price').text(var_price);
          $('.price_main_wp').find('.price').text(var_price);
          window.updateBundleTotalPrice();
        });

  
    $('body').on('click','.case_set_drop li',function() {
      var optionValue = jQuery(this).find('a').attr('id');
      var variant_id = $(this).parents('.case_set_drop').find('select option:selected').attr('data-variant-id');
      var case_variant_title = $(this).parents('.case_set_drop').find('select option:selected').attr('data-handleized-value');
      var selected_option = $(this).parents('.case_set_drop').find('select option:selected');
      var product_id = selected_option.attr('data-product-id');
      var product_url = '/products/case-new';

      $(this).parents('.case_set_drop').find('select').val(optionValue);
      let hide_mag_safe = true;
      $('.mag_safe_drop').find('select option').each(function(i,e){
        if(case_variant_title == $(e).attr('data-handleized-value')){
          $(e).closest('select').val($(e).attr('value'));
          $('.mag_safe_drop').slideDown();
          hide_mag_safe = false;
        }
      });
      if(hide_mag_safe && $('.mag_safe_drop').length) {
        $('.mag_safe_drop').slideUp();
        $('.mag_safe_drop input[id="mag-safe-checkbox"]').prop('checked',false).trigger('change');
      }
      
      update_add_on_input(optionValue, variant_id, selected_option, product_id, product_url);
      window.updateBundleTotalPrice();
    });
    
  function update_add_on_input(optionValue, variant_id, selected_option, product_id, product_url) {
    if(selected_option.attr('data-available') == 'true'){
      $('.case-error-msg').hide();
      if(!$('#change_btn_text_by_jquery').is('[data-ossa-confessa]')) $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('ADD TO BAG');
      // $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('ADD TO BAG');
    }
    else if(!$('.case_set_drop').hasClass('case_backInstok')){
      $('.case-error-msg').hide();
    }
    else{
      $('.case-error-msg').show();
    }
    $('.form-klaviyo-bis').attr('data-variant-id',variant_id);
    $('.form-klaviyo-bis').attr('data-product-id',product_id);
      $.get(product_url +'?variant='+variant_id+'?view=main-product',function( data ) {
        var data_popup = $(data).find('.form-klaviyo-bis').html();
        $('.form-klaviyo-bis').html(data_popup);
      });
    
    
      console.log('remove case pro out');
    // console.log('optionValue',optionValue);
    if(optionValue != 'Phone Size'){
      if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('CONFESS TO BUY');
      }else if($('.product-form__submit.pre_order').length > 0 && selected_option.attr('data-available') == 'true'){
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('PREORDER');
      }else{
        
        if(selected_option.attr('data-available') == 'true'){
          $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('ADD TO BAG');
        }else{
          $('#change_btn_text_by_jquery').addClass('disabled-btn').find('span').text('Out Of Stock');
        }
      }
      console.log('remove case pro');
      $('.case_pro').remove();
      if($('.ty_var_item input[id="type2"]').prop('checked') == true){
      $('.product-form__input_btn').append('<input type="hidden" name="id[]" value="'+selected_option.attr('data-variant-id')+'" class="case_pro" >')
      }
    }
  }
    
  $('body').on('change','.mag_safe_drop input[id="mag-safe-checkbox"]',function(e){
    if($(this).prop('checked') == true){
      var selected_option = $(this).closest('.mag_safe_drop').find('select option:selected');
      var var_cord_price = parseFloat(extractNumber($('.color_var_wp input:checked').attr('data-cord-price')))*100;
      var case_price = parseFloat(extractNumber(selected_option.attr('data-price')))*100;
      console.log(var_cord_price + case_price);
      var cord_case_price = Shopify.formatMoney(var_cord_price + case_price, window.variantStrings.mf);
      $('.cordcase-price').text(cord_case_price + ' Set');
      if(!$('#change_btn_text_by_jquery').is('[data-ossa-confessa]')) $('.cordcase-item h4.price').text(cord_case_price); 
      window.updateBundleTotalPrice();

      var product_id = selected_option.attr('data-product-id');
      var variant_id = selected_option.attr('data-variant-id');
      var product_url = '/products/magsafe-case';
      var optionValue = selected_option.attr('value');
      update_add_on_input(optionValue, variant_id, selected_option, product_id, product_url);
    }else {
      var selected_option = $('.case_set_drop').find('select option:selected');
      var cord_case_price = parseFloat(extractNumber($('.color_var_wp input:checked').attr('data-cordcase-price')))*100;
      cord_case_price = Shopify.formatMoney(cord_case_price, window.variantStrings.mf);
      $('.cordcase-price').text(cord_case_price + ' Set');
      if(!$('#change_btn_text_by_jquery').is('[data-ossa-confessa]')) $('.cordcase-item h4.price').text(cord_case_price);
      // $('.cordcase-item h4.price').text(cord_case_price);
      window.updateBundleTotalPrice();

      var variant_id = selected_option.attr('data-variant-id');
      var product_id = selected_option.attr('data-product-id');
      var product_url = '/products/case-new';
      var optionValue = selected_option.attr('value');

      update_add_on_input(optionValue, variant_id, selected_option, product_id, product_url);
    }
    
  });

  

  $('body').on('click','.case-error-msg .case-notify',function(e){
    e.preventDefault();
    $('.case-bis.form-klaviyo-bis, body').addClass('klaviyo-active');
  });
  
 document.body.addEventListener('change', function(e) {
  const target = e.target;
  if (target.matches('input[name="type_var_qty"]')) {
    const form = document.querySelector('.main_product');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    qtyInput.value = target.value === '1 pack' ? 1 : 2;
  }
});
  
$('body').on('change','input[name="type_var"]',function(e){
      e.preventDefault();
  if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
    $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('CONFESS TO BUY');
  } else {
    $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('ADD TO BAG');
  }
  $('.case-error-msg').hide();
  $('.case_pro').remove();
  if($(this).val() == 'CordCase' ){
    $('.case_set_drop').slideDown();
    if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
      $('#change_btn_text_by_jquery').find('span').text('CONFESS TO BUY');
    } else {
      $('#change_btn_text_by_jquery').addClass('disabled-btn').find('span').text('Select Phone size');
    }
  }else{
      $('.case_set_drop').slideUp();
      if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('CONFESS TO BUY');
      } 
      //magSafe code start
      if($('.mag_safe_drop').length){
        $('.mag_safe_drop').slideUp();
        $('.mag_safe_drop input[id="mag-safe-checkbox"]').prop('checked',false).trigger('change');
      }
      //magSafe code end
      $('.case_set_drop .drop').text('- SELECT -');
      $('.case_set_drop select').val('Phone Size');
      if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('CONFESS TO BUY');
      } else if($('.product-form__submit.pre_order').length > 0 ){
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('PREORDER');
      } else {
        $('#change_btn_text_by_jquery').removeClass('disabled-btn').find('span').text('ADD TO BAG');
      }
  }
  window.updateBundleTotalPrice();
});
    

  $('.scroll-text-out').infiniteslide({
      speed: 50,
      direction: 'left',
      pauseonhover: false,
      clone: 20,
  });

	function setSplPageCookie(cname,cvalue,exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	  
	function getSplPageCookie(cname) {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');
		for(let i = 0; i < ca.length; i++) {
		  let c = ca[i];
		  while (c.charAt(0) == ' ') {
			c = c.substring(1);
		  }
		  if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		  }
		}
		return "";
	}
	  
	function checkSplPageCookie(cname) {
		let spl_page = getSplPageCookie(cname);
		if (spl_page != "") {
		  return true;
		} else {
			setSplPageCookie(cname, 1, 1);
			return false;
		}
	}

	function checkCookiePolicyPage(cname) {
		let cookie_policy = getSplPageCookie(cname);
		if (cookie_policy != '') {
			return true;
		} else {
			return false;
		}
	}

	function setCookieForCookiePolicy(cname) {
		setSplPageCookie(cname, 1, 1);
	}

	// check if cookie exist for splash page. If exists then don't display splash page.
	if (!checkSplPageCookie("SPLASHPAGESHOWN")) {
		// splesh screen start here 
		$('#splesh--screen--id').show().delay(3000).fadeOut(500);
		//  window.location.href = '/collections/shop-metal';

	}else{
		jQuery("body").css("overflow","visible");
		if( customPath == 'index' ){
			//window.location.href = '/collections/shop-metal';
		}

	}

	// accept and close cookie policy start here.

	if (checkCookiePolicyPage("COOKIEPOLICYACCEPTED")) {
		$("#hide_afer_accept").hide();
	}

	$("#accept").click(function(){
		$("#hide_afer_accept").hide(500);
		setCookieForCookiePolicy("COOKIEPOLICYACCEPTED");
	});

	// accept and close cookie policy end here.

	setTimeout(function(){
		jQuery("body").css("overflow","visible");
	},3000);

	$('#splesh--screen--id').click(function() {
		$(this).hide();
	});

	var slength = jQuery('#splesh--screen--id').length;
	if(slength==0){
		jQuery("body").css("overflow","visible");
	}
	
	// header fixed top start here

	$(window).scroll(function(){
		var div_height = $(".top--header").height();
		if($(document).scrollTop() >= div_height ) {
			$("#header_fixed").addClass("scrolled");
		}

		else {
			$("#header_fixed").removeClass("scrolled");
		}
	});

	// header fixed top end here 


	// change image on hover start here 
	// var get_img_url='';
	// function mouse_hover(){
	// 	var image_url = jQuery(this).find(".media--hover-effect img").attr("srcset");
	// 	var nex_img_url = jQuery(this).find(".media--hover-effect img").data("nextimg");
	// 	jQuery(this).find(".media--hover-effect img").attr("srcset",nex_img_url);
	// 	get_img_url = image_url;
	// 	}
	// 	function mouse_out(){
	// 		jQuery(this).find(".media--hover-effect img").attr("srcset",get_img_url);
	// 		get_img_url='';
	// 	}
	// if(jQuery(".list-products").length>0){
	// 	jQuery(".list-products").hover(mouse_hover,mouse_out);
	// }
	// change image on hover End here 



	// top bar start here
	jQuery(".top--header").slideDown('slow');
	jQuery(".close--header").click(function() {
		jQuery(".top--header").slideUp('slow');
		let all_marque_divs = [];
		let marquer_div = document.getElementsByClassName("marquee--container")[0].children;
		for (i = 0; i <= marquer_div.length - 1; i++) {
            all_marque_divs.push(marquer_div[i].id);
        }
		if (all_marque_divs.length > 0) {
			let marque_cookie_val = all_marque_divs.toString();
		    
			// set cookie for marque
			setSplPageCookie("SITEHEADERMARQUE", marque_cookie_val, 1);
		}


	});
	// top bar end here

	// hide/show header marque.
	let getBannerCookie = getSplPageCookie("SITEHEADERMARQUE");
	if (getBannerCookie != '') {
		let marque_div_ids = getBannerCookie.split(",");
		let marquer_divs = document.getElementsByClassName("marquee--container")[0].children;
		let remaining = 0;
		for (i = 0; i <= marquer_divs.length - 1; i++) {
            if(marque_div_ids.includes(marquer_divs[i].id)) {
				document.getElementById(marquer_divs[i].id).style.display = "none";
			} else {
				remaining++;
			}
        }
		
		// if no new marque then hide banner bar.
		if (remaining == 0) {
			jQuery(".top--header").hide();			
		}
	}

	// header search start here box
	$('#search-button').click(function(){
		$(this).hide();
		$('#search--input').show();
		$('#Search').focus();
	});
	$('#close-search-box').click(function(){
		$('#search--input').hide();
		$('#search-button').show();
	});

	$(document).click(function (e) {
		if ($(e.target).closest("#srchform").length === 0) {
			$("#search--input").hide();
		$("#search-button").show();
		}
	});

	// header search box end here

	// 	accordion start here
	$(".accordion-header").hover(function () {
		$(this).toggleClass("before--image--hover");
	});

	$(".accordion-header").on("click", function() {
		if ($(this).hasClass("active")) {
		  $(this).removeClass("active");
		  $(this)
			.siblings(".accordion-body")
			.slideUp(200);
		} else {
		  $(".accordion-header").removeClass("active");
		  $(this).addClass("active");
		  $(".accordion-body").slideUp(200);
		  $(this)
			.siblings(".accordion-body")
			.slideDown(200);
		}
	  });
	// 	accordion end here


	// Toggle Menu start here 

	// $(document).ready(function(){
		// $(function() {




  function setMobileMenuHeight() {
    var headerHeight = $('.main--header').outerHeight();
    var menuHeight = window.innerHeight - headerHeight;

    $('.toggle--menu--items').css(
      'max-height',
      menuHeight + 'px'
    );
  }

  $('#toggle--menu').click(function () {
    var menu = $(this).next('.toggle--menu--items');

    $('#toggle--menu').toggleClass('active--color');

    setMobileMenuHeight();

    if ($(this).hasClass('active--color')) {
      menu.css('max-height', window.innerHeight - $('.main--header').outerHeight() + 'px');
    } else {
      menu.css('max-height', '0px');
    }
  });

  $('#close--mobile--menu').click(function () {
    $('#toggle--menu').removeClass('active--color');
    $('.toggle--menu--items').css('max-height', '0px');
  });

  $(document).click(function (e) {
    if ($(e.target).closest('.toggle--menu--container').length === 0) {
      $('#toggle--menu').removeClass('active--color');
      $('.toggle--menu--items').css('max-height', '0px');
    }
  });

  $(window).on('resize', function () {
    if ($('#toggle--menu').hasClass('active--color')) {
      setMobileMenuHeight();
    }
  });






		// $(document).click(function(e) 
		// { 
		// var target = e.target; 
		// if (!$(target).is('#toggle--menu') && !$(target).parents().is('#toggle--menu')) 
		// //{ $('.toggle--menu--items').hide(); }
		//   { $('.toggle--menu--items').slideUp(); }
		// });
		// });	
	// });

	// Toggle Menu End here 

// scroll menu change start here
	// $(document).on('scroll', '.sub_category_bg', function(e){
	// 	console.log('skjsk');
	// 	if($(this).scrollTop() == 0) console.log($(this).find($('.full-unstyled-link'))[0].html());
	// });

	$(window).scroll(function(){

		const scrollTop = $(window).scrollTop();

		$.each( $('.sub_category_bg'), function( key, elem ) {

			distance = (scrollTop - $(elem).offset().top);

			if (distance <= 60 && distance > 0) {
				// console.log(distance);
				const link_value = $(elem).find('#scroll--get--link').attr("href");
				const lable = $(elem).find('#scroll--get--link').html();
				// console.log(lable);
				$('a[aria-current="page"]').attr("href",link_value);
				$('a[aria-current="page"]').html('> '+ lable);
			} else {
				//actions...
			}
		})
		
	});
	

// scroll menu change End here 

$('.nice-select').each(function () {
  var select = $(this),
      name = select.attr('name');

  select.hide();
  select.wrap('<div class="nice-select-wrap"></div>');

  var parent = select.parent('.nice-select-wrap');

  parent.append(
    '<div class="nice-select-wrap-wp"><ul id="' + name + '"></ul></div>'
  );

  select.find('option').each(function () {
    var option = $(this),
        value = option.attr('value') || '',
        value_handle = value.replace(/\s+/g, '_'),
        selected = option.is(':selected'),
        var_id = option.attr('data-variant-id') || '',
        label = option.text();

    // Add selected label
    if (selected) {
      parent.prepend(
        '<a href="#" class="drop sentence-case">' + label + '</a>'
      );
    }

    // Add option list
    parent.find('.nice-select-wrap-wp ul').append(
      '<li class="' + value_handle + '">' +
        '<a href="#" id="' + value + '" data-variant-id="' + var_id + '">' +
          label +
        '</a>' +
      '</li>'
    );
  });

  // If no selected option found
  if (!parent.find('.drop').length) {
    var firstText = select.find('option:first').text();
    parent.prepend(
      '<a href="#" class="drop sentence-case">' + firstText + '</a>'
    );
  }

  // Toggle dropdown
  parent.find('.drop').on('click', function (e) {
    e.preventDefault();
    parent.toggleClass('down');
    parent.find('.nice-select-wrap-wp').slideToggle(300);
  });

  // Select option
  parent.find('ul').on('click', 'a', function (e) {
    e.preventDefault();

    var niceOption = $(this),
        value = niceOption.attr('id'),
        text = niceOption.text();

    select.val(value).trigger('change');

    parent.find('.drop').text(text);
    if($('#change_btn_text_by_jquery').is('[data-ossa-confessa]')){
      $('#change_btn_text_by_jquery').find('span').text('CONFESS TO BUY');
    }

    parent.removeClass('down');
    parent.find('.nice-select-wrap-wp').slideUp(300);

    if (text.includes('Not sure, this is a gift')) {
      $('.case_gift').show();
    } else {
      $('.case_gift').hide();
    }

    // Sentence case convert
    function toSentenceCase(str) {
      return str
        .toLowerCase()
        .replace(/(^\s*\w|[.!?]\s*\w)/g, function (match) {
          return match.toUpperCase();
        });
    }

    $('.sentence-case').each(function () {
      $(this).text(toSentenceCase($(this).text()));
    });

    $('#change_btn_text_by_jquery').removeClass('disabled-btn');
  });
});


// cart-related js start

   $('body').on('click','.related_wrraper .rel-pro-btn',function(e){
    e.preventDefault();
      $('.rel-pop-sec').addClass('popup-active');
   });
   $("body").on('click', '.related_wrraper .rel_pro_close', function(e){
    e.preventDefault();
      $('.related_wrraper').hide();
   });
  $("body").on('click', '.rel-pop-sec .popup-closer, .rel_pop_overlay', function(e){
    e.preventDefault();
    $('.rel-pop-sec').removeClass('popup-active');
  });

  // popup button
   function rel_pro_btn(){
   var flag = false; 
    var btn = $('.rel-pop-sec .rel-pop-btn');
     btn.removeAttr('disabled');
     btn.text('Add to bag');
    $(".rel-pop-sec .rel-pro-var select.re-pro-select").each(function( index ) {
      var selected_val = $(this).val();
      if(!selected_val && flag == false){
        btn.attr('disabled', 'disabled');
        btn.html('SELECT PHONE SIZE');
        flag = true;
      }
    });
  }
  
  $( document ).ready(function() {
    rel_pro_btn();

$('body').on('click', '.rel-pop-sec .rel-pro-var .nice-select-wrap ul li', function(e){
    const parent = $(this).closest('.rel-pop-info');
    $('.re-pro-select').trigger('change');
    rel_pro_btn();
    var price = $('.re-pro-select option:selected').attr('data-price');
     

    let re_pro_case_variant_title = $('.re-pro-select option:selected').attr('data-handleized-value');
    let re_pro_hide_mag_safe = true;
    $(parent).find('.rel_pro_mag_safe_drop select option').each(function(i,e){
      if(re_pro_case_variant_title == $(e).attr('data-handleized-value')){
        $(parent).find('.rel_pro_mag_safe_drop select').val($('.re-pro-select option:selected').val());
        $('.rel_pro_mag_safe_drop').slideDown();
        re_pro_hide_mag_safe = false;
        if($(parent).find('.rel_pro_mag_safe_drop input[id="rel-pro-mag-safe-checkbox"]').prop('checked') == true){
          $('.rel-pop-price').text($('#rel-pro-mag-safe-variants option:selected').attr('data-price'));
        } else {
          $('.rel-pop-price').text(price);
        }
      }
    });
    
    if(re_pro_hide_mag_safe && $(parent).find('.rel_pro_mag_safe_drop').length) {
      $(parent).find('.rel_pro_mag_safe_drop').slideUp();
      $(parent).find('.rel_pro_mag_safe_drop input[id="rel-pro-mag-safe-checkbox"]').prop('checked',false).trigger('change');
      $('.rel-pop-price').text(price);
    } 
    if ($(parent).find('.rel_pro_mag_safe_drop').length == 0){
      $('.rel-pop-price').text(price);
    }
  });
  
  $('body').on('change', '#rel-pro-mag-safe-checkbox',function(){
    let parent = $(this).closest('.rel-pop-info');
    if($(this).prop('checked') == true){
      let price = $(parent).find('#rel-pro-mag-safe-variants option:selected').attr('data-price');
      $(parent).find('.rel-pop-price').text(price);
    } else {
      let price = $(parent).find('.re-pro-select option:selected').attr('data-price');
      $(parent).find('.rel-pop-price').text(price);
    }
  });
  
  $('body').on('click', '.rel-pop-sec .rel-pop-btn', function(e){
    e.preventDefault();
    var btn = $(this);
    if (btn.closest('form').find('input[id="rel-pro-mag-safe-checkbox"]').prop('checked') == true){
      var variant = $('#rel-pro-mag-safe-variants option:selected').attr('data-variant-id');
    } else{
      var variant = $('.rel-pop-sec .re-pro-select option:selected').attr('data-id');
    }
    var quan = $('.rel_pop_addtocart .quantity__input').val();
    
      $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id: variant, quantity: quan},    
      dataType: 'json',
      success: function(){
        fetch(`${routes.cart_update_url}`, config)
            .then((response) => {
              return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                updateItemsHtml(parsedState);
                document.body.classList.add('testbody');
                document.getElementById("drawer-name").classList.add("is-active","is-visible");
                document.body.classList.add('has_drawer');
                $('.rel-pop-sec').removeClass('popup-active');
            }).catch((e) => {
              console.error(e);
            });  
        }
    });
  }); 
  
  }); 
  
 // cart-related js end 

  
 // Sort Filter for collection & home page
  
$('body').on('click','.nice-select-wrap-wp ul li',function(e){
  e.preventDefault();
 var url = location.pathname; 
 var cur_url = window.location.href; 
 var handle = $('.product-grid-container').attr('data-handle');  
 var criteria = $(this).attr('class');
 if(url.indexOf('/search') !== -1){
     var url_path = cur_url +'&sort_by=' + criteria ; 
 }else{
   if(url == '/'){
     var url_path = '/collections/'+handle+'?sort_by=' + criteria ;
   }else{
     var url_path = url +'?sort_by=' + criteria ;
   } 
 }
   $.ajax({
      url: url_path,
      type:'GET',
      success: function(data) {
        var data = $(data).find('.product-grid-container').html();
        $('.product-grid-container').html(data);
      }
    });
  }); 

  $("body").on('click', '.klaviyo-bis-trigger', function (e) {
    e.preventDefault();
    $('.form-klaviyo-bis, body').addClass('klaviyo-active');
  });
  $("body").on('click', '.form-klaviyo-close, .klaviyo-overlay', function (e) {
    e.preventDefault();
    $('.form-klaviyo-bis, body').removeClass('klaviyo-active');
  });
});

  

// track page fly plane animation//
$(document).ready(function(){
		$(".track123_two_form_wrapper").after( "<div class='fly-plan'><svg viewBox='0 -100 3387 1270' xmlns='http://www.w3.org/2000/svg'><path id='planePath' class='planePath' d='M0,177.6c811.3-70.3,1215.5,142.9,1696.1,238.7,480.7,95.8,751.2-224.1,552.6-380.1-198.6-156-571.8,240.4,38.3,381,610.1,140.5,1031.7-223.6,1578.9-329'/><g id='plane'><path d='M148.9,24.5c-.8-1.5-1.2-2.9-2.3-4-.4-1.3-1.7-2-3-2.7s-3.2-1.2-4.5-1.8-3-1.6-4.5-1.8-5-1-6.9-1.5l-1.7-.9-8.5-.6c-2.6-.3-5.2-.6-8.3-1.1s-7-.4-10.2-.4-7.6-1.3-11.3-1.6-8.3-1.1-12.4-1.6l-10.9-1.3c-1.9-.5-3.9-1-5.6-.8l-7.2-1-12.4-1.6c-1.9-.5-4.1-.5-6.1-1-3.7-.3-7.4-.6-10.9-.2-2.2,0-4.6,.3-6.8,.3-1.7,.2-3.3,0-4.8-.3C8.3-.2,5.4,0,3,.3c0,0-.9,.6-1.1,1.1-.7,1.3,0,3.3,1,4.4l6.8,5.8c2.6,2.5,5.1,4.9,7.7,7.4s5.3,4.5,7.5,6.7c3,2.7,6.4,5.6,9.2,8.7,1.3,.7,1.7,3.1,.6,4.2l-.2,.4c-1.8,2.4-4.2,4.9-6,7.3-.5,.9-.9,1.7-2,2.8-1.6,1.9-3.6,3.6-5.1,5.5s-3.6,4.7-5.8,6.8h0c-2.7,3-5.1,5.5-7.6,8.1-1.6,3-4.2,4.9-6.9,6.8l-.9,1.7c.2,1.7,1.7,3.1,3.8,3.1,2.2,0,4.1,.5,5.9,.3,3.3,0,6.3-.5,9.8-.9,1.1,0,2.4-.4,3.1-.6l8.5-.5c1.1,0,2.4-.4,3.5-.4,2.2,0,4.8-.8,7,.4s1.3,.7,.8,1.5l-2.1,7.1c-1.4,3.7-3,7.8-4.4,11.4-.7,1.3-1.2,3.2-1,5-.3,1.5,.8,2.6,2.3,2.9,.4,.2,1.7-.2,2.6-.8,.5-.9,.9-1.7,1.8-2.4,.5-.9,.7-1.3,1.6-1.9,2.2-1,4-2.3,6.2-3.3,2-1.7,4.2-2.7,6.6-4.2l4.4-3.2c3.3-2.1,6.6-4.2,10.2-6.7s9.1-6.8,13.5-9.9c2.7-1.9,6-4,8.6-5.9s6-4,8.6-5.9,6-4,8.6-5.9,5.1-3.4,7.7-5.3,4.4-3.2,6.4-4.9,4.9-4,7.5-5.9l.4,.2,.7-1.3c3.1-1.7,5.7-3.6,8-5.7,2.7-1.9,5.1-4.5,7.1-7.2,.5-.9,1.1-2.2,.3-3.7l.6,.9Zm-114.6,4.4c-2.1-2.2-4.1-3.8-6.4-5.6s-3.4-2.9-4.7-4.7-3-2.7-4.5-4l-2.6-2.5-5.8-5.8c1.5-.8,3.1-1.7,5.3-1.6,1.7-.2,3.5-.4,5-.1,2.6,.3,5.4,.1,8,.4l9.6,.6c5.4,.1,10.9,1.3,15.8,2.3,1.3,.7,3,.5,4.8,.3,5.6,.8,11.3,1.6,16.9,2.3,5.6,.8,9.5,1.7,14.8,2.3s10.9,1.3,16.3,1.5c3.7,.3,7.2,1,10.4,1.1,2.6,.3,4.8,.3,7,.4,.9,.5,1.9,.5,2.8,.9s2.2,1.1,3.2,1.2c1.5,.3,3.5,.7,5,1l-.2,.4-7.2,1.1c-3.1,.6-5.5,1-8.3,1.1-4.2,.6-8.1,.7-11.8,1.5-3.7,.8-7.2,1.1-10.3,1.7l-7.2,1.1-11.4,1.7c-3.1,.6-6.6,.9-9.6,1.5-3.5,.4-7,.7-10.3,1.7-2.6,.8-5.5,1-8.3,1.1-2.6,.8-5.5,1-8.3,1.1-1.1,0-2.6-.3-3.7-1.4-1.7-.9-3.2-2.2-4.7-3.6l.2,.7Zm9.9,44.9c-3.3,1-6.4,1.6-9.6,1.5-1.7,.2-3.5,.4-5.2,.5s-2.8,.2-3.9,.1c-1.1,0-2.4,.4-3.5,.4l-.4-.2c-1.7-.9-3.9,.1-5.7,.3l-1.3-.7,.7-1.3c1.3-.4,2.6-.8,3.5-1.4,2-.6,3.5-1.4,5.3-2.7,1.1-1.1,2.9-1.2,4.6-1.4s3.7-1.9,5.7-2.5,5.3-2.7,7.5-3.8,5.1-2.3,7.9-3.5c-.2,.4-.5,.9-.3,1.5-1.4,3.7-2.8,7.3-4.2,11-.2,.4-.7,1.3-1.3,1.5l.2,.7Zm13.3-21l-.4-.2c-2.6-1.4-4.6,.3-6.8,1.4s-4,2.3-5.5,3.1-4.4,2.1-6.4,2.7c-4.4,2.1-8.6,3.7-13,5.8-2.2,1-4.6,2.5-6.8,3.5s-3.3,1-4.8,1.9h0c.7-1.3,1.4-2.6,2.5-3.6,.9-1.7,2.2-3.2,3.8-4.1,3.1-1.7,4.9-5.1,7.6-7,.5-.9,1.6-1.9,2-2.8l.5-.9c2.5-3.6,5.4-7.1,8.5-9.8,1.1-1.1,2.2-2.1,2.9-3.4s1.1-1.1,2.4-.4,1.7,.9,3.3,0c2-.6,3.9-1.2,5.9-1.8,2-.6,3.3-1,5.3-1.6s3.1-.6,4.2-.6l4.2-.6,9-1.3c1.7-.2,3.7-.8,5.7-1.4s4.8-.8,6.8-1.4l6.6-.9,9.2-1.8c2.4-.4,4.4-1,6.6-.9,4.2-.6,7.6-.9,11.8-1.5l5.9-.7c2.2,0,4.2-.6,6.1-1.2,.4,.2,1.5,.3,2.2,0l-.9,1.7c-4.8,1.9-9.9,4.1-14.3,6.2-3.5,1.4-7,2.9-10.8,3.7s-9.2,2.8-13.4,4.5c-1.3,.4-2.2,1-3.3,1-4.6,1.4-8.6,2.6-13.2,4.1-3.3,1-5.9,1.8-8.8,3.1l-.5,.9-6.8,1.4-5.7,1.4-1.3,1.5Zm82.8-22.3c-3.8,3-6.9,5.7-10.6,8.7-2,1.7-4.9,2.9-7.5,4.8s-3.8,3-5.8,4.7c-.5,.9-1.8,1.3-2.4,1.5-3.3,2.1-6.9,4.6-9.7,7l-8.6,5.9c-.9,.6-2.4,1.5-3.3,2.1l-.2,.4c-5.1,4.5-11.3,7.8-16.8,12-3.5,2.5-6.4,4.9-9.5,7.6-2.4,1.5-5.1,3.4-7.5,4.8s-5.1,3.4-7.5,4.8-4,3.4-7.3,3.3c.9-1.7,1.4-3.7,1.9-5.6,1.2-3.2,2.1-6.1,2.8-9.5,.5-1.9,.8-4.6,1.2-6.5,1.6-4.1,3.5-8.6,4.9-13.4l.7-1.3c-.2-1.7,1.8-3.4,3.1-3.8,2-.6,3.7-.8,5.3-1.6s5.5-2.1,8.1-2.9h0l7.2-2.2,.4,.2,9.5-4.4,.4,.2c5.9-1.8,11.2-3.5,16.7-5.5,4.8-1.9,9.4-3.3,14.3-5.1,2.9-1.2,5.7-2.5,8.3-3.3l10.1-4.6s.7-.2,1.3-.4h0l-.7,1.3h0l1.3,.7Z'/></g><!-- Define the motion path animation --><animateMotion xlink:href='#plane' attributeName='opacity' from='1' to='0' dur='8s' repeatCount='1' rotate='auto'><mpath xlink:href='#planePath' /></animateMotion></svg><div>" );	

setTimeout(function(){
var titlelength = $(".track123_result_title_card").length;
var formlength  = $(".track123_two_form_wrapper").length;

if(titlelength && formlength){
$(".fly-plan").addClass("fly-plan-top");
}
}, 500);
});
// track page fly plane animation end//

$(document).ready(function(){
  $('body').on('input', '#alphabet-charm-text', function () {
    $(this).val(
      $(this).val()
        .toUpperCase()
        .replace(/[^A-Z ]/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^\s+/, '')
    );
    window.updateBundleTotalPrice();
  });
  $('body').on('change', '#icon-charm-variants input[name="quantity"]', function(){
    window.updateBundleTotalPrice();
  });
});


window.updateBundleTotalPrice = function () {
  if($('.alphabet-charm-wrp').length || $('.icon-charm-main-wrp').length){
    let total = 0;

    /* --------------------------
      1. Selected variant price
    -------------------------- */
    if($('.ty_var_item:has(input:checked)').length){
      $('.ty_var_item:has(input:checked) .price').each(function () {
        const price = parseFloat(extractNumber($(this).text()))*100;
        if (!isNaN(price)) {
          total += price;
        }
      });
    } else{
      const price = parseFloat(extractNumber($('.color_var_wp :radio').attr('data-cord-price')))*100;
      if (!isNaN(price)) {
          total += price;
      }
    }


    /* --------------------------
      2. Alphabet charm price
    -------------------------- */
    const text = $('#alphabet-charm-text').val() || '';

    const letters = text
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .split('');

    const letterCount = {};
    letters.forEach(l => {
      letterCount[l] = (letterCount[l] || 0) + 1;
    });


    $('#alphabet-charm-variants option').each(function () {
      const letter = ($(this).data('title') || '')
        .toString()
        .trim()
        .toUpperCase();

      const price = Number($(this).data('price'));

      //console.log('Checking:', letter, letterCount[letter], price);

      if (letterCount[letter] > 0 && !isNaN(price)) {
        total += price * letterCount[letter];
      }
    });

    /* --------------------------
      3. Icon charm price
    -------------------------- */
    $('#icon-charm-variants input').each(function () {
      const qty = parseInt($(this).val(), 10);
      const price = parseFloat($(this).data('price'));

      if (!isNaN(qty) && !isNaN(price) && qty > 0) {
        total += price * qty;
      }
    });

    /* --------------------------
      4. Update total
    -------------------------- */
    $('.bundle-total-price').html(Shopify.formatMoney(total, window.variantStrings.mf));
  }
};

document.addEventListener('click', function (e) {
  const moreSwatch = e.target.closest('[class~="4_more_swatch"]');
  if (!moreSwatch) return;

  const swatchList = moreSwatch.closest('ul');
  if (!swatchList) return;

  swatchList.querySelectorAll('li.hide_var').forEach(function (li) {
    li.classList.remove('hide_var');
  });

  moreSwatch.classList.add('active');
  moreSwatch.style.display = 'none';
});


document.addEventListener('change', function (event) {
  const input = event.target.closest('.cl_var_item input');
  if (!input) return;

  const card = input.closest('.product-card-wrapper');
  if (!card) return;

  /* FIRST IMAGE*/
  const primaryImage = card.querySelector('[data-product-image]');
  if (primaryImage) {
    if (input.dataset.image) {
      primaryImage.src = input.dataset.image;
    }
    if (input.dataset.imageSrcset) {
      primaryImage.srcset = input.dataset.imageSrcset;
    }
    if (input.dataset.imageAlt) {
      primaryImage.alt = input.dataset.imageAlt;
    }
  }

  /* SECOND IMAGE */
  const secondaryImage = card.querySelector('[data-product-secondary-image]');
  if (secondaryImage) {
    if (input.dataset.secondImage) {
      secondaryImage.src = input.dataset.secondImage;
      if (input.dataset.secondImageSrcset) {
        secondaryImage.srcset = input.dataset.secondImageSrcset;
      }
      if (input.dataset.secondImageAlt) {
        secondaryImage.alt = input.dataset.secondImageAlt;
      }
      secondaryImage.style.display = '';
    } else {
      secondaryImage.style.display = 'none';
    }
  }

  /* VARIANT PRICE */
  const priceElement = card.querySelector('[data-product-price]');
  if (priceElement && input.dataset.cordPrice) {
    priceElement.textContent = input.dataset.cordPrice;
  }

  /* ACTIVE SWATCH */
  const swatchList = input.closest('ul');
  if (swatchList) {
    const allSwatchInputs = swatchList.querySelectorAll('.swatch_color input[type="radio"]');

    allSwatchInputs.forEach(function (swatchInput) {
      swatchInput.checked = false;
      swatchInput.removeAttribute('checked');
    });

    input.checked = true;
    input.setAttribute('checked', '');
  }
});



